import React from 'react';
import PropTypes from 'prop-types';
import EditableFormTable from '../../../core/form/EditableTable';
import Button from '../../../core/form/Button';
import LocaleSelect from '../../../core/form/LocaleSelect';

const LocalizationList = (props) => {
  return (
    <EditableFormTable
      fetching={props.fetching}
      lazy={true}
      columns={[
        {
          label: 'Key',
          path: 'key',
          sort: true,
          defaultSortOrder: 'ascend',
        },
        {
          label: 'English',
          render: (text, record) => record.translations.find((translation) => translation.locale === 'en')?.value,
          path: 'en',
          editable: true,
          width: '25%',
        },
        {
          label: (
            <LocaleSelect
              onChange={(value) =>
                props.onChange(null, null, null, {
                  firstLocaleSelect: value,
                  secondLocaleSelect: props.secondLocaleSelect,
                })
              }
              label=""
              textFunc={(option) => `${option.language}`}
              value={props.firstLocaleSelect}
              formItemStyle={{ marginBottom: '0px' }}
            />
          ),
          render: (text, record) => {
            const translation = record.translations.find(
              (translation) => translation.locale === props.firstLocaleSelect
            );
            return translation && translation.value;
          },
          path: props.firstLocaleSelect,
          editable: true,
          width: '25%',
        },
        {
          label: (
            <LocaleSelect
              onChange={(value) =>
                props.onChange(null, null, null, {
                  firstLocaleSelect: props.firstLocaleSelect,
                  secondLocaleSelect: value,
                })
              }
              label=""
              textFunc={(option) => `${option.language}`}
              value={props.secondLocaleSelect}
              formItemStyle={{ marginBottom: '0px' }}
            />
          ),
          render: (text, record) => {
            const translation = record.translations.find(
              (translation) => translation.locale === props.secondLocaleSelect
            );
            return translation && translation.value;
          },
          path: props.secondLocaleSelect,
          editable: true,
          width: '25%',
        },
      ]}
      actions={[
        <Button icon="delete" onClick={(record) => props.onDelete(record)} />,
        <Button icon="form" onClick={(record) => window.open(`/localization/${record.id}`, '_blank')} />,
      ]}
      rows={props.items}
      onDelete={props.onDelete}
      onSave={props.onSave}
      onChange={props.onChange}
      pagination={props.pagination}
    />
  );
};

LocalizationList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    pageSize: PropTypes.number,
    total: PropTypes.number,
  }),
  onChange: PropTypes.func,
  firstLocaleSelect: PropTypes.string,
  secondLocaleSelect: PropTypes.string,
};

export default LocalizationList;
